var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoMenuRadial01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1435",
    d: "M35.5,18.3h-6.7c0-3.8-1.5-7.4-4.1-10l4.8-4.8C33.3,7.4,35.5,12.8,35.5,18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1439",
    d: "M28.8,18.3H22c0-2-0.8-3.9-2.2-5.2l4.8-4.8C27.3,10.9,28.8,14.6,28.8,18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1440",
    d: "M19.9,23.6l4.8,4.8c-2.7,2.7-6.3,4.2-10,4.1v-6.7C16.6,25.7,18.5,25,19.9,23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1442",
    d: "M14.6,25.7v6.7c-3.8,0-7.4-1.5-10-4.1l4.8-4.8C10.8,24.9,12.7,25.7,14.6,25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1443",
    d: "M14.6,4.1v6.7c-2,0-3.9,0.8-5.2,2.2l0,0L4.6,8.3C7.3,5.6,10.9,4.1,14.6,4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1445",
    d: "M22.1,18.3h6.7c0,3.8-1.5,7.4-4.1,10l-4.8-4.8C21.3,22.2,22,20.3,22.1,18.3L22.1,18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1446",
    d: "M4.6,8.3l4.8,4.8c-1.4,1.4-2.2,3.3-2.2,5.2H0.5C0.5,14.6,2,10.9,4.6,8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1447",
    d: "M9.4,23.6l-4.8,4.8c-2.7-2.7-4.2-6.3-4.1-10h6.7C7.2,20.3,8,22.2,9.4,23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1449",
    d: "M24.6,8.3l-4.8,4.8c-1.4-1.4-3.3-2.2-5.2-2.2V4.1C18.4,4.1,22,5.6,24.6,8.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMenuRadial01);
export default __webpack_public_path__ + "static/media/ico-menu-radial-01.477ac43bf0a9fbba5054ea40064cc040.svg";
export { ForwardRef as ReactComponent };